import apiPaths from 'config/apiPaths';

import axiosInstance from './axios';

export interface CronJobResponse {
  name: string;
  description: string;
}

export interface CronJobRunResponse {
  name: string;
  status: string;
}

export const getCronJobs = (): Promise<CronJobResponse[]> =>
  axiosInstance.get<CronJobResponse[]>(apiPaths.CRON_JOBS).then(({ data }) => data);

export const runCronJob = (name: string): Promise<CronJobRunResponse> =>
  axiosInstance
    .post<CronJobRunResponse>(`${apiPaths.CRON_JOBS}/${encodeURIComponent(name)}/run`)
    .then(({ data }) => data);
